import { StepStatus as ChakraStepStatus } from '@chakra-ui/react'

import { StepStatusProps } from './StepStatus.types'

export default function StepStatus(props: StepStatusProps) {
  return <ChakraStepStatus {...props} />
}
